import { render, staticRenderFns } from "./TopicCombinationChoice.vue?vue&type=template&id=168b7c55&scoped=true"
import script from "./TopicCombinationChoice.vue?vue&type=script&lang=js"
export * from "./TopicCombinationChoice.vue?vue&type=script&lang=js"
import style0 from "./TopicCombinationChoice.vue?vue&type=style&index=0&id=168b7c55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168b7c55",
  null
  
)

export default component.exports